import { message } from "antd";
import axios from "axios";
import {
  EstimateApi,
  EstimateDuplicateApi,
  EstimateExcelApi,
  EstimateListApi,
  EstimateRevisionDataApi,
  EstimateCreateBudgetItems,
  MDCategoryApi,
} from ".";

export const fetchAllEstimates = (projectId) => {
  return axios
    .get(`${EstimateApi}?project=${projectId}`)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return [];
    });
};

export const fetchEstimatesList = (projectId) => {
  return axios
    .get(`${EstimateListApi}?project=${projectId}`)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return [];
    });
};

export const fetchBranchEstimatesList = ({ params }) => {
  return axios
    .get(`apiV1/estimate-info/`, {
      params: { ...params },
    })
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return [];
    });
};

export const fetchEstimateRevisionData = (estimate_no) => {
  return axios
    .get(`${EstimateRevisionDataApi}?estimate_no=${estimate_no}`)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return [];
    });
};
export const createEstimateDuplicate = (estimate_id) => {
  return axios
    .get(`${EstimateDuplicateApi}?estimate_id=${estimate_id}`)
    .then((res) => {
      return true;
    })
    .catch(() => {
      return false;
    });
};

export const estimateExcelApi = (estimate_id) => {
  return axios
    .get(`${EstimateExcelApi}${estimate_id}/`)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};

export const getEstimateDetails = (estimateId) => {
  return axios
    .get(`${EstimateApi}?id=${estimateId}`)
    .then((response) => {
      if (Array.isArray(response.data?.results)) {
        const estimate = response.data?.results[0];
        return estimate;
      } else {
        return response.data;
      }
    })
    .catch(() => {
      message.info("Error getting preview details", 3);
    });
};

export const changeEstimateStatus = ({ data, estimate_id }) => {
  return axios
    .put(`${EstimateApi}${estimate_id}/`, data)
    .then((res) => {
      return res?.data;
    })
    .catch(() => {
      message.error("Something went wrong!");
    });
};

export const estimateDashboardData = () => {
  return axios
    .get("apiV1/user-dashboard/")
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};

export const mdCategories = () => {
  return axios
    .get(MDCategoryApi, {
      headers: {
        Authorization: undefined,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};

export const changeEstimateAssignee = ({ data, estimate_id }) => {
  return axios
    .put(`${EstimateApi}${estimate_id}/`, data)
    .then((res) => {
      message.success({
        content: "Assigned",
        duration: 2,
        key: "assigning",
      });
    })
    .catch((err) => {
      message.error({
        content: "Some error occured please try again later.",
        duration: 3,
        key: "assigning",
      });
    });
};

export const createBudgetItemFromEstimate = ({ estimate_id, project_id }) => {
  message.loading({
    content: "Creating items..",
    duration: 5,
    key: "estimate-items",
  });
  return axios
    .get(
      `${EstimateCreateBudgetItems}?estimate_id=${estimate_id}&project_id=${project_id}`
    )
    .then((res) => {
      message.success({
        content: "Items created succesfully",
        duration: 2,
        key: "estimate-items",
      });
      return res.data;
    })
    .catch(() => {
      message.error({
        content: "Issue creating items please try again later.",
        duration: 3,
        key: "estimate-items",
      });
      return null;
    });
};

export const resendEstimateMail = (estimate_id) => {
  return axios
    .get(`${EstimateRevisionDataApi}?estimate_id=${estimate_id}`)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};
